import {Component, Input, OnInit} from '@angular/core';
import {environment} from './../../../../environments/environment';
import {BsModalRef} from 'ngx-bootstrap/modal';

declare let $: any;

@Component({
    selector: 'app-tooltip-modal',
    templateUrl: './tooltip-modal.component.html',
    styleUrls: ['./tooltip-modal.component.scss']
})

export class TooltipModalComponent implements OnInit {

    public title: string;
    public text: string;
    public warning = false;
    public page: string;
    modalID = 'tooltipModal';
    modalSelector = '#' + this.modalID;
    public focused: any;
    public canShowModalFooter = true;
    KEYCODE_TAB = 9;
    @Input()
    tooltipInfo;
    public tooltips: any = environment.tooltips;

    constructor(private bsModalRef: BsModalRef) {
    }

    ngOnInit() {
        const tooltip = this.tooltips[this.tooltipInfo.tooltip];
        this.title = tooltip?.title.replace(/\{estimatedSavings\}/g, this.tooltipInfo.bannerConfiguration.estimatedSavings).replace(/\{banner\}/g, this.tooltipInfo.bannerConfiguration.banner);
        this.text = tooltip?.text.replace(/\{loyaltyPgmName\}/g, this.tooltipInfo.bannerConfiguration.loyaltyPgmName)
            .replace(/\{banner\}/g, this.tooltipInfo.bannerConfiguration.banner);
        // To show the text from Api for WUG Location
        // (tooltipInfo.pickUpInstructions1) ? this.text = tooltipInfo.pickUpInstructions1 : '';
        this.warning = tooltip?.warning;
    }

    close() {
        this.bsModalRef.hide();
    }
}
